import { useEffect, useMemo, useState } from 'react'
import { artGobblersOnChainApi } from 'web3/onchain-api/gobblers'

import useContracts from 'hooks/mint/useContracts'
import { useAccount, useProvider } from 'wagmi'
import { DEFAULT_CHAIN_ID } from 'config'
import { BigNumber, BigNumberish } from 'ethers'
import { useNftsInWalletByCollection } from 'hooks/nfts/useNftsInWallet'
import { useSmartContractReadCall } from 'hooks/react-query-typechain/useSmartContractReadCall'

type RevealData = [BigNumber, BigNumber, BigNumber, BigNumber, boolean] & {
  // randomSeed: BigNumber
  // nextRevealTimestamp: BigNumber
  // lastRevealedId: BigNumber
  // toBeRevealed: BigNumber
  // waitingForSeed: boolean
}

const useNumberOfGobblersAwaitingReveal = (
  revealData: RevealData | null | undefined,
  currentNonLegendaryId: BigNumberish | null | undefined,
) => {
  const lastRevealedId = revealData?.[2].toNumber()
  let numberOfGobblersAwaitingReveal: undefined | number
  if (
    currentNonLegendaryId !== undefined &&
    currentNonLegendaryId !== null &&
    lastRevealedId !== undefined
  ) {
    const lastMintedId = parseInt(currentNonLegendaryId.toString(10), 10)
    numberOfGobblersAwaitingReveal = lastMintedId - lastRevealedId
  }

  return numberOfGobblersAwaitingReveal
}

const useNumberOfGobblersUserIsAwaitingReveal = (
  revealData: RevealData | null | undefined,
  currentNonLegendaryId: BigNumberish | null | undefined,
) => {
  const chainId = DEFAULT_CHAIN_ID
  const [gobblerContract] = useContracts(chainId)
  const provider = useProvider()
  const { address } = useAccount()

  const gobblersOwned = useNftsInWalletByCollection(address, gobblerContract?.address, chainId)

  const gobblerIds = useMemo(
    () => gobblersOwned?.data?.ownedNfts.map((gobbler) => parseInt(gobbler.id.tokenId)),
    [gobblersOwned?.data?.ownedNfts],
  )

  const lastRevealedId = revealData?.[2].toNumber()

  const gobblersIdsAwaitingRevealForUser = useMemo(() => {
    if (lastRevealedId === undefined) {
      return undefined
    }
    return gobblerIds?.filter((id) => id > lastRevealedId)
  }, [gobblerIds, lastRevealedId])

  return gobblersIdsAwaitingRevealForUser
}

// function useTransformedGobblerRevealData(): [RevealData | null, number, number] {
//   // const [revealData, setRevealData] = useState<RevealData | null>(null)
//   // const [unrevealedToken, setUnrevealedToken] = useState(-1)
//   const chainId = DEFAULT_CHAIN_ID
//   const [gobblerContract] = useContracts(chainId)
//   // const { address } = useAccount()

//   // const gobblersOwned = useNftsInWalletByCollection(address, gobblerContract?.address, chainId)

//   const gobblersRevealDataQuery = useSmartContractReadCall(gobblerContract, 'gobblerRevealsData')
//   const currentNonLegendaryIdQuery = useSmartContractReadCall(gobblerContract, 'currentNonLegendaryId')

//   const newRevealData = gobblersRevealDataQuery.data
//   const currentNonLegendaryId = currentNonLegendaryIdQuery.data

//   const lastRevealedId = newRevealData?.lastRevealedId.toNumber()
//   const lastMintedId = currentNonLegendaryId?.toNumber()
//   let numberOfGobblersAwaitingReveal: undefined  | number
//   if (lastMintedId !== undefined && lastRevealedId !== undefined) {
//     numberOfGobblersAwaitingReveal = lastMintedId - lastRevealedId
//   }

//   // useEffect(() => {
//   //   // const gobblerIds =
//   //   //   gobblersOwned?.data?.ownedNfts.map((gobbler) => parseInt(gobbler.id.tokenId)) || []

//   //   if (!gobblerContract || !provider || revealData) return
//   //   artGobblersOnChainApi
//   //     .getGobblerRevealData(gobblerContract.address, provider)
//   //     .then(async (newRevealData) => {
//   //       const lastRevealedId = newRevealData.lastRevealedId.toNumber()
//   //       const lastMintedId = (await gobblerContract.currentNonLegendaryId()).toNumber()
//   //       const unrevealedAmount = lastMintedId - lastRevealedId

//   //       setUnrevealedAmount(unrevealedAmount)
//   //       setRevealData(newRevealData)

//   //       // One-way, so won't revert to -1 if we refresh post-reveal.
//   //       const newestTokenId = Math.max(...gobblerIds)
//   //       if (newestTokenId > lastRevealedId) {
//   //         setUnrevealedToken(newestTokenId)
//   //       }
//   //     })
//   // }, [revealData, gobblerContract, provider, gobblersOwned?.data?.ownedNfts])
//   // return [revealData, numberOfGobblersAwaitingReveal, unrevealedToken]
// }

export { useNumberOfGobblersAwaitingReveal, useNumberOfGobblersUserIsAwaitingReveal }
